export default {
  server: {
    server_name: "Server",
    player_name: "Karakter",
    nobind: "Belum di-Bind",
  },
  pop: {
    pleaseIn: "Silahkan tulis",
    pleaseSelect: "Pilih",
    phone: "Silakan tulis nomor HP",
    gnjoy: "Silakan tulis akun GNJOY",
    onlineNo: "Silakan tulis akun RO Online",
    onlineServe: "Silakan pilih server RO Online",
    twilightServe: "Silakan pilih server RO Twilight",
    twilightRole: "Silakan pilih karakter RO Twilight",
    tips1:
      "*Bind akun Ragnarok Online: Forever Love dan selesaikan misi tertentu di halaman event dan dapatkan hadiah di atas. ",
    tips2:
      "*Jika tidak bind akun RO Online, otomatis dianggap melepaskan hadiah Ragnarok Online: Forever Love, namun tidak ada pengaruh sama hadiah 《RO Twilight》",
    //
    pleaseLogin: "Silakan login terlebih dahulu",
    changeSuccess: "Tautan ulang berhasil",
    giftSuccess: "Pack berhasil dikirimkan",
    phoneBlock: "Nomor telepon tidak boleh kosong",
    correctPhone: "Silakan masukkan nomor telepon yang benar",
    selectServe: "Silakan pilih server",
  },
};
